import { ERROR_COLORS, GRAY_COLORS, INFO_COLORS, PRIMARY_COLORS, SUCCESS_COLORS, WARNING_COLORS } from 'asterX-UI'

const HOLD = 'HOLD'

const NEW = 'NEW'
const NEW2 = 'Новый'
const COMPLETED = 'COMPLETED'
const PAYMENT_MADE = 'PAYMENT_MADE'

const PROMISE = 'PROMISE'
const PAYMENT_UNREGISTERED = 'PAYMENT_UNREGISTERED'
const CALL_BACK_LATER = 'CALL_BACK_LATER'

const PROMISE_NOT_FULFILLED = 'PROMISE_NOT_FULFILLED'
const PAYMENT_NO_INTENTION = 'PAYMENT_NO_INTENTION'
const PROVIDE_INFORMATION_REFUSE = 'PROVIDE_INFORMATION_REFUSE'
const DEATH = 'DEATH'

const LEGAL = 'LEGAL'
const OFFBALANCE = 'OFFBALANCE'
const BUYBACK = 'BUYBACK'

const PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
const CALL_RESET_OUTGOING = 'CALL_RESET_OUTGOING'
const BUSY = 'BUSY'
const NO_ANSWER = 'NO_ANSWER'
const MESSAGE_SENT = 'MESSAGE_SENT'
const UNAVAILABLE_SUBSCRIBER = 'UNAVAILABLE_SUBSCRIBER'
const VISIT = 'VISIT'
const CALL_BACK = 'CALL_BACK'
const PROVIDE_INFORMATION_CONFIRM = 'PROVIDE_INFORMATION_CONFIRM'
const PAYMENT_NO_FUNDS = 'PAYMENT_NO_FUNDS'
const CALL_INFORMATION = 'CALL_INFORMATION'

const DEBTOR_DEATH = 'DEBTOR_DEATH'
const WILL_PASS_INFORMATION_TO_DEBTOR = 'WILL_PASS_INFORMATION_TO_DEBTOR'
const REFUSAL_TO_PASS_INFORMATION_TO_DEBTOR = 'REFUSAL_TO_PASS_INFORMATION_TO_DEBTOR'
const NO_FUNDS_TO_PAY = 'NO_FUNDS_TO_PAY'
const UNREGISTERED_PAYMENT = 'UNREGISTERED_PAYMENT'
const NO_INTENTION_TO_PAY = 'NO_INTENTION_TO_PAY'
const WROTE_DEFERMENT_APPLICATION = 'WROTE_DEFERMENT_APPLICATION'
const VOLUNTARY_IMPLEMENTATION = 'VOLUNTARY_IMPLEMENTATION'
const FRAUD = 'FRAUD'
const DEBTOR_NOT_FOUND = 'DEBTOR_NOT_FOUND'
const HANDED_OVER_TO_COURT = 'HANDED_OVER_TO_COURT'
const SUBSCRIBER_NOT_AVAILABLE = 'SUBSCRIBER_NOT_AVAILABLE'
const OUTGOING_CALL_DROP = 'OUTGOING_CALL_DROP'
const CANCELLATION_OF_WRIT_OF_EXECUTION = 'CANCELLATION_OF_WRIT_OF_EXECUTION'
const IN_PROGRESS_AT_CHSI = 'IN_PROGRESS_AT_CHSI'
const INSCRIPTION_WAS_TRANSMITTED = 'INSCRIPTION_WAS_TRANSMITTED'
const TRANSFERRING_THE_INSCRIPTION = 'TRANSFERRING_THE_INSCRIPTION'

const IN_PROGRESS = 'IN_PROGRESS'
const IN_PROGRESS_LAWYER = 'IN_PROGRESS_LAWYER'
const CLOSED_WITHOUT_MANAGER = 'CLOSED_WITHOUT_MANAGER'
const RESTRUCTURED = 'RESTRUCTURED'
const FULL_COMPLETED = 'FULL_COMPLETED'

export const getStatusLabel = status => {
  switch (status) {
    case 'NEW':
      return 'Новый'
    case 'IN_PROGRESS':
      return 'В процессе'
    case 'IN_PROGRESS_LAWYER':
      return 'В процессе (Юрист)'
    case 'OFFBALANCE':
      return 'OFFBALANCE'
    case 'CLOSED_WITHOUT_MANAGER':
      return 'Закрыто без менеджера'
    case 'RESTRUCTURED':
      return 'Реструктурировано'
    case 'FULL_COMPLETED':
      return 'Полностью завершено'
    case 'COMPLETED':
      return 'Завершено'
    default:
      return 'Новый'
  }
}

export const getStatusColor = code => {
  const colors = {
    // PRIMARY_COLORS
    [HOLD]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [NEW]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [NEW2]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [IN_PROGRESS]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [IN_PROGRESS_LAWYER]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    // SUCCESS_COLORS
    [PAYMENT_MADE]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [COMPLETED]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [FULL_COMPLETED]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [CLOSED_WITHOUT_MANAGER]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    // WARNING_COLORS
    [PROMISE]: {
      border: `1px solid ${WARNING_COLORS[200]}`,
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400]
    },
    [CALL_BACK_LATER]: {
      border: `1px solid ${WARNING_COLORS[200]}`,
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400]
    },
    [PAYMENT_UNREGISTERED]: {
      border: `1px solid ${WARNING_COLORS[200]}`,
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400]
    },
    // ERROR_COLORS
    [PROMISE_NOT_FULFILLED]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    [PAYMENT_NO_INTENTION]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    [PROVIDE_INFORMATION_REFUSE]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    // GRAY_COLORS
    [DEATH]: {
      backgroundColor: GRAY_COLORS[700],
      color: GRAY_COLORS[50],
      border: `1px solid ${GRAY_COLORS[700]}`
    },
    [LEGAL]: {
      backgroundColor: GRAY_COLORS[100],
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[200]}`
    },
    [RESTRUCTURED]: {
      backgroundColor: GRAY_COLORS[100],
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[200]}`
    },
    [OFFBALANCE]: {
      backgroundColor: GRAY_COLORS[100],
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[200]}`
    },
    [BUYBACK]: {
      backgroundColor: GRAY_COLORS[100],
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[200]}`
    },
    // WARNING ERROR
    [PARTIAL_PAYMENT]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [CALL_RESET_OUTGOING]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [BUSY]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [NO_ANSWER]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [MESSAGE_SENT]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [UNAVAILABLE_SUBSCRIBER]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [VISIT]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [CALL_BACK]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [PROVIDE_INFORMATION_CONFIRM]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [PAYMENT_NO_FUNDS]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [CALL_INFORMATION]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    // Дополненные статусы
    [DEBTOR_DEATH]: {
      backgroundColor: GRAY_COLORS[700],
      color: GRAY_COLORS[50],
      border: `1px solid ${GRAY_COLORS[700]}`
    },
    [WILL_PASS_INFORMATION_TO_DEBTOR]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    },
    [REFUSAL_TO_PASS_INFORMATION_TO_DEBTOR]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [NO_FUNDS_TO_PAY]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [UNREGISTERED_PAYMENT]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    },
    [NO_INTENTION_TO_PAY]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    [WROTE_DEFERMENT_APPLICATION]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    },
    [VOLUNTARY_IMPLEMENTATION]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [FRAUD]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    [DEBTOR_NOT_FOUND]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [HANDED_OVER_TO_COURT]: {
      backgroundColor: GRAY_COLORS[100],
      color: GRAY_COLORS[700],
      border: `1px solid ${GRAY_COLORS[200]}`
    },
    [SUBSCRIBER_NOT_AVAILABLE]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [OUTGOING_CALL_DROP]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[400],
      border: `1px solid ${ERROR_COLORS[100]}`
    },
    [CANCELLATION_OF_WRIT_OF_EXECUTION]: {
      backgroundColor: ERROR_COLORS[200],
      color: ERROR_COLORS[500],
      border: `1px solid ${ERROR_COLORS[300]}`
    },
    [IN_PROGRESS_AT_CHSI]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    },
    [INSCRIPTION_WAS_TRANSMITTED]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    },
    [TRANSFERRING_THE_INSCRIPTION]: {
      backgroundColor: WARNING_COLORS[50],
      color: WARNING_COLORS[400],
      border: `1px solid ${WARNING_COLORS[200]}`
    }
  }

  return colors?.[code] || {}
}
